export const CHUNK_SIZE_SVG = 4;
export const BASE_PRICE = 275;